export const theme = {
  token: {
    colorPrimary: '#4f46e5',
  },
};